import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "antd";
import { COLOR_STATUS_ACTIVE_BG, COLOR_STATUS_ACTIVE_TEXT, COLOR_STATUS_ERROR_BG, COLOR_STATUS_ERROR_TEXT, COLOR_STATUS_NEUTRAL_BG, COLOR_STATUS_NEUTRAL_TEXT, COLOR_STATUS_WARNING_BG, COLOR_STATUS_WARNING_TEXT } from "../../../../../style/antdTheme.js";
const HUES = {
    active: {
        background: COLOR_STATUS_ACTIVE_BG,
        color: COLOR_STATUS_ACTIVE_TEXT
    },
    warning: {
        background: COLOR_STATUS_WARNING_BG,
        color: COLOR_STATUS_WARNING_TEXT
    },
    error: {
        background: COLOR_STATUS_ERROR_BG,
        color: COLOR_STATUS_ERROR_TEXT
    },
    neutral: {
        background: COLOR_STATUS_NEUTRAL_BG,
        color: COLOR_STATUS_NEUTRAL_TEXT
    }
};
const StatusPill = ({ kind, label, tooltip })=>{
    const { background, color } = HUES[kind];
    const pillNode = /*#__PURE__*/ _jsxs("span", {
        className: "rc-account-v2-subscription-card__status-pill",
        style: {
            background,
            color
        },
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "rc-account-v2-subscription-card__status-dot",
                style: {
                    background: color
                },
                "aria-hidden": true
            }),
            label
        ]
    });
    return tooltip ? /*#__PURE__*/ _jsx(Tooltip, {
        title: tooltip,
        children: pillNode
    }) : pillNode;
};
export { StatusPill };
